import React from 'react';
import { createStructuredSelector } from 'reselect';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { FormattedMessage } from 'react-intl';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { Alert, Row, Col, Button, Form, Input } from 'antd';
import reducer from 'containers/App/reducer';
import saga from 'containers/App/saga';

import {
  selectIsLoading,
  selectErrors,
  selectHasErrors,
} from 'containers/App/selectors';
import { sendUpdateProfile } from 'containers/App/actions';

import { validatePhone } from '../CarQuote/validator';
import messages from './messages';

class FormProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      profile: props.profile || {},
      submitting: false,
      submitted: false,
      hasErrors: false,
      errors: {
        name: false,
        phone: false,
      },
    };
  }

  resetErrors = input => {
    if (typeof input !== 'undefined') {
      this.setState({
        errors: { ...this.state.errors, [input]: false },
      });
    } else {
      this.setState(() => ({
        errors: {
          name: false,
          phone: false,
        },
        hasErrors: false,
      }));
    }
  };

  isValid() {
    let valid = true;
    const { profile, errors } = this.state;

    if (profile.phone !== '' && !validatePhone(profile.phone)) {
      valid = false;
      errors.phone = true;
    } else {
      errors.phone = false;
    }

    if (!profile.business_name || profile.business_name.trim() === '') {
      valid = false;
      errors.business_name = true;
    } else {
      errors.business_name = false;
    }

    if (!profile.email || profile.email.trim() === '') {
      valid = false;
      errors.email = true;
    } else {
      errors.email = false;
    }

    this.setState(() => ({ errors }));
    return valid;
  }

  handleSubmit = e => {
    e.preventDefault();
    this.resetErrors();

    const { profile } = this.state;

    if (this.isValid()) {
      if (!this.state.submitting) {
        this.props.sendUpdateProfile(profile);
        this.setState({ submitting: false, submitted: true });
      }
    }
  };

  onInputChange = e => {
    const value = e.target.value;
    const name = e.target.name;
    this.resetErrors(name);

    this.setState({
      profile: { ...this.state.profile, [name]: value },
    });
  };

  onAlertDismiss = () => {
    this.setState({ submitted: false });
  };

  render() {
    let { profile, errors, submitted } = this.state;
    const { hasErrors } = this.props;
    const profileHasErrors = hasErrors('profile')
    errors = { ...errors, ...this.props.updateErrors.profile || {} };

    return (
      <div id="ProfileForm" className="mt-4">
        {submitted || profileHasErrors ?
          <Alert
            showIcon
            closable
            type={profileHasErrors ? 'error' : 'success'}
            afterClose={this.onAlertDismiss}
            message={profileHasErrors ? 'Si sono verificati degli errori, controllare i dati inseriti' : 'Aggiornamento avvenuto con successo'}
            className="mb-3"
          />
          : null
        }
        <div className="form-content">
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Ragione sociale"
                  required
                  help={errors.business_name && (errors.business_name[0] || 'Questo campo è obbligatorio')}
                  validateStatus={errors.business_name ? 'error' : null}
                >
                  <Input
                    placeholder="Ragione sociale"
                    name="business_name"
                    value={profile.business_name}
                    onChange={this.onInputChange}
                    onKeyUp={this.onInputChange}
                    size="large"
                    required
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Nome completo"
                  help={errors.name && (errors.name[0])}
                  validateStatus={errors.name ? 'error' : null}
                >
                  <Input
                    placeholder="Nome completo"
                    name="name"
                    value={profile.name}
                    onChange={this.onInputChange}
                    onKeyUp={this.onInputChange}
                    size="large"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label="Email"
                  required
                  help={errors.email && (errors.email[0] || 'Questo campo è obbligatorio')}
                  validateStatus={errors.email ? 'error' : null}
                >
                  <Input
                    placeholder="Indirizzo email"
                    name="email"
                    type="email"
                    value={profile.email}
                    onChange={this.onInputChange}
                    onKeyUp={this.onInputChange}
                    size="large"
                    required
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Numero di telefono"
                  required
                  help={errors.phone && (errors.phone[0] || 'Questo campo è obbligatorio')}
                  validateStatus={errors.phone ? 'error' : null}
                >
                  <Input
                    placeholder="Numero di telefono"
                    name="phone"
                    type="number"
                    value={profile.phone}
                    onChange={this.onInputChange}
                    onKeyUp={this.onInputChange}
                    size="large"
                    required
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Titolo"
                >
                  <Input
                    placeholder="Ruolo ricoperto"
                    name="title"
                    value={profile.title}
                    onChange={this.onInputChange}
                    onKeyUp={this.onInputChange}
                    size="large"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              label="Informazioni di contatto"
              help={errors.contact_info && errors.contact_info[0]}
              validateStatus={errors.contact_info ? 'error' : null}
            >
              <Input.TextArea
                placeholder="Informazioni di contatto"
                name="contact_info"
                value={profile.contact_info}
                onChange={this.onInputChange}
                onKeyUp={this.onInputChange}
                size="large"
              />
            </Form.Item>
          </Form>
          <Row>
            <Col span={24}>
              <Button
                type="primary"
                color="primary"
                className="float-right"
                onClick={this.handleSubmit}
              >
                <FormattedMessage {...messages.updateProfile} />
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    sendUpdateProfile: profile => dispatch(sendUpdateProfile(profile)),
  };
}

const mapStateToProps = createStructuredSelector({
  isLoading: selectIsLoading(),
  updateErrors: selectErrors(),
  hasErrors: (state, errorDomain) => selectHasErrors(state, errorDomain),
});

const withReducer = injectReducer({ key: 'user', reducer });
const withSaga = injectSaga({ key: 'user', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(FormProfile);
